export function formatDate(dateString: string) {
	const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

	let date = new Date(dateString);

	let day = String(date.getDate()).padStart(2, "0");
	let month = monthNames[date.getMonth()];
	let year = date.getFullYear();

	return `${day} ${month} ${year}`;
}

export function debounce<T extends (...args: any[]) => any>(func: T, wait: number): T & { cancel: () => void } {
	let timeout: NodeJS.Timeout | null = null;

	const debounced = (...args: Parameters<T>) => {
		if (timeout) {
			clearTimeout(timeout);
		}

		timeout = setTimeout(() => {
			func(...args);
			timeout = null;
		}, wait);
	};

	// Add a cancel method to clear the timeout
	debounced.cancel = () => {
		if (timeout) {
			clearTimeout(timeout);
			timeout = null;
		}
	};

	return debounced as T & { cancel: () => void };
}
export function truncateText(text: string, maxLength = 30) {
	if (!text) return "";
	if (text.length <= maxLength) return text; // Return text if it's short enough

	const partLength = Math.floor((maxLength - 3) / 2); // Calculate length of each part (subtract 3 for the ellipses)
	const start = text.substring(0, partLength); // Get the starting part
	const end = text.substring(text.length - partLength); // Get the ending part

	return `${start} ... ${end}`; // Combine with ellipses in the middle
}
export function capitalizeFirstLetter(string: string) {
	return string.charAt(0).toUpperCase() + string.slice(1);
}

export const isEmptyObj = (obj: any) => {
	for (const prop in obj) {
		if (Object.hasOwn(obj, prop)) {
			return false;
		}
	}

	return true;
};
function getDateSuffix(day: number) {
	if (day > 3 && day < 21) return "th"; // covers 11th, 12th, 13th, etc.
	switch (day % 10) {
		case 1:
			return "st";
		case 2:
			return "nd";
		case 3:
			return "rd";
		default:
			return "th";
	}
}

export function formatDispatchDate(date: any) {
	const day = date.getDate();
	const suffix = getDateSuffix(day);
	const month = date.toLocaleString("default", { month: "long" });
	const year = date.getFullYear();

	return `${day}${suffix} ${month} ${year}`;
}
